import { DigitalJourneyBodyShop } from "types/DigitalJourneySession";

export const MOCK_BODYSHOPS_BY_POSTCODE: Array<DigitalJourneyBodyShop> = [
  {
    id: 1,
    name: "AutoFix Garage",
    region: "Lombardy",
    province: "MI",
    city: "Milan",
    address: "Via Roma 12",
    postalCode: "20100",
    phoneNumber: "+39 02 1234 5678",
    email: "contact@autofix.it",
    vatNumber: "IT12345678901",
    enabled: true,
  },
  {
    id: 2,
    name: "CarCare Center",
    region: "Lazio",
    province: "RM",
    city: "Rome",
    address: "Piazza Venezia 45",
    postalCode: "00186",
    phoneNumber: "+39 06 8765 4321",
    email: "info@carcare.it",
    vatNumber: "IT98765432109",
  },
  {
    id: 3,
    name: "Speedy Repairs",
    region: "Tuscany",
    province: "FI",
    city: "Florence",
    address: "Viale Europa 88",
    postalCode: "50126",
    phoneNumber: "+39 055 123 4567",
    email: "support@speedyrepairs.it",
    vatNumber: "IT19283746501",
    enabled: false,
  },
];
